<template>
  <details class="cw-panel" @toggle="opened">
    <summary>Büroeinstellungen für dieses Studio</summary>
    <p v-if="error" class="cw-error" role="alert">{{ error }}</p>
    <form v-if="settings" class="cw-stack cw-top-space" @submit.prevent="save">
      <label class="cw-check"><input v-model="settings.sendCustomerMail" type="checkbox" :disabled="busy">Vertragskopie an Kunden senden</label>
      <label class="cw-check"><input v-model="settings.notifyStudio" type="checkbox" :disabled="busy">Studio über Online-Abschlüsse informieren</label>
      <label class="cw-label">Studio-E-Mail-Adressen<textarea v-model="recipients" class="cw-input" rows="3" :disabled="busy" placeholder="Eine E-Mail-Adresse pro Zeile"></textarea></label>
      <label class="cw-label">IBAN für gewöhnliche Rechnungen<input v-model="settings.bankAccount" class="cw-input" :disabled="busy" autocomplete="off"></label>
      <p class="cw-small">QR-Rechnungen folgen weiterhin der Berg-Vorverkaufsregel. Testverträge versenden keine E-Mails und werden nicht an TAC übertragen.</p>
      <p v-if="message" class="cw-notice" role="status">{{ message }}</p>
      <button type="submit" class="cw-button" :disabled="busy">{{ busy ? 'Wird gespeichert …' : 'Einstellungen speichern' }}</button>
    </form>
  </details>
</template>
<script>
import api from "@/api/contractWorkspaceOfficeApi"
import { errorMessage } from "@/api/contractWorkspaceApi"
export default {
  props: { studioId: { type: String, required: true } },
  data: () => ({ settings: null, recipients: "", error: "", message: "", busy: false, baseline: "" }),
  computed: { formKey() { return this.settings ? JSON.stringify({ sendCustomerMail: this.settings.sendCustomerMail, notifyStudio: this.settings.notifyStudio, recipients: this.recipients, bankAccount: this.settings.bankAccount }) : "" } },
  watch: { busy(value) { this.$emit("busy", value) }, formKey(value) { this.$emit("dirty", !!this.baseline && value !== this.baseline) } },
  methods: {
    async opened(event) {
      if (!event.target.open || this.settings || this.busy) return
      this.busy = true
      try { this.settings = await api.settings(this.studioId); this.recipients = this.settings.recipients.join("\n"); this.baseline = this.formKey }
      catch (error) { this.error = errorMessage(error) }
      finally { this.busy = false }
    },
    async save() {
      this.busy = true; this.error = ""; this.message = ""
      try { this.settings = await api.saveSettings(this.studioId, { ...this.settings, recipients: this.recipients.split(/[\n;,]+/).map(value => value.trim()).filter(Boolean) }); this.baseline = this.formKey; this.$emit("dirty", false); this.message = "Büroeinstellungen gespeichert." }
      catch (error) { this.error = errorMessage(error) }
      finally { this.busy = false }
    },
  },
}
</script>
